<ng-container *ngIf="toolbarPosition() !== 'top'">
  <div quill-editor-element></div>
</ng-container>
<ng-content select="[quill-editor-toolbar]"></ng-content>
<ng-container *ngIf="toolbarPosition() === 'top'">
  <div quill-editor-element></div>
</ng-container>
<ng-content></ng-content>
